import { Skeleton } from '@oneaudi/unified-web-alpha-components';
import { ItemCardStyle } from '~/components/item-card/styles/item-card-style';

export const CardSkeleton = () => (
	<>
		{Array.from({ length: 6 }, (_, index) => (
			<ItemCardStyle key={index}>
				<div className="placeholder" aria-label="">
					<Skeleton variant="oval" height={'179px'} />
				</div>
				<div className="equipment-content">
					<Skeleton variant="oval" height={'20px'} width={'200px'} />
					<Skeleton variant="oval" height={'20px'} width={'100px'} />
					<Skeleton variant="oval" height={'20px'} width={'100px'} />
				</div>
			</ItemCardStyle>
		))}
	</>
);
